import { WorkspaceMembers } from '@/types/generated/graphql';

export function sortMembers(members: (WorkspaceMembers | null)[] | null, loggedInUserId: number | null | undefined) {
  const accountOwner = members?.find((member) => member?.user?.id === loggedInUserId);
  const otherMembers = members?.filter((member) => member?.user?.id !== loggedInUserId);
  const filteredMembers = accountOwner ? [accountOwner, ...(otherMembers ? otherMembers : [])] : members;
  return filteredMembers || [];
}
